import { Input } from 'react-daisyui'
import { Button } from '@/components/Button.tsx'
import { toast } from 'react-toastify'
import { IconExternalLink, IconShare2 } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

export default function ShareableInput({ value }: { value: string}) {
  const { t } = useTranslation()
  const canShare = navigator.share != null
  function onCopyLinkClick() {
    navigator.clipboard.writeText(value).then(() => {
      toast(t('common.linkCopied'), {closeButton: true, autoClose: 2000})
    })
  }

  async function onShareLinkClick() {
    await navigator.share({
      url: value,
    })
  }


  return <div className='flex flex-col gap-2'>
    <Input className='bg-neutral' color='secondary' value={value} onFocus={e => e.target.select()} />
    <div className='flex flex-row gap-2'>
      <Button color='primary' className='flex-1' onClick={onCopyLinkClick}><IconExternalLink /> {t('common.copyLink')}</Button>
      { canShare && <Button color='primary' className='flex-1' onClick={onShareLinkClick}><IconShare2 /> {t('common.share')}</Button> }
    </div>
  </div>
}
